import { useMutation } from '@tanstack/vue-query'
import { useEventStore } from '../../common/eventStore'
import { Site } from '../models/site'
import { create } from '../siteService'
import { ToastEvent } from '../../common/models/toastEvent'


export const siteKeys = {
    all: ['sites'] as const,
    lists: () => [...siteKeys.all, 'list'] as const,
}

export function useSiteCreateMutation() {
    const eventStore = useEventStore()

    return useMutation<{ site: Site }, Error, { form: { name: string, timezone: string} }>({
        mutationFn: async (variables) => {
            return create(variables.form)
        },
        onSuccess: async () => {
            const event = new ToastEvent('Saved')
            eventStore.addEvent(event)
        },
    })
}